<template>
  <v-row dense>
    <v-col
        cols="12"
        sm="4"
        v-for="item in items"
        :key="item.id"
    >
      <v-list-item
          class="border"
          style="text-decoration: none;"
          @click="$emit('close'); $router.push('/journal/'+item.id+'?itemid='+item.id)"
          :to="'/journal/'+item.id+'?itemid='+item.id"
      >
        <v-list-item-content>
          <v-list-item-subtitle>
            Description:{{item.description}}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            Date:{{item.entry_date | humanDate}}
          </v-list-item-subtitle>

        </v-list-item-content>
      </v-list-item>

    </v-col>
    <v-col cols="12" sm="4">
      <v-card outlined tile>
        <v-card-text>
          <v-btn
              large
              text
              rounded
              color="blue"
              to="/journal"
              block
              @click="$emit('close'); $router.push('/journal')"
          >Go to Journals <v-icon>mdi-arrow-right</v-icon></v-btn>

        </v-card-text>
      </v-card>
    </v-col>

  </v-row>

</template>

<script>
export default {
  props:['items'],
  name: "SearchJournals"
}
</script>

<style scoped>

</style>